import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { InspectionAttachmentsSurface } from './InspectionAttachmentsSurface';
export { InspectionAttachmentsSurface };
/**
 * `InspectionAttachments` — the composition root, mounted by `react_component` from the
 * inspection show page when `new_attachment_direct_uploads_enabled?` is true.
 * `InspectionAttachmentsSurface` configures the shared `@features/Attachments` surface; this
 * wrapper's own job is only the `QueryClientProvider` every mounted island owns for itself
 * (mirrors `BuildingAttachments`).
 */
function InspectionAttachments(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InspectionAttachmentsSurface, Object.assign({}, props))));
}
export default InspectionAttachments;
